import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
  @Input() info;
  @Input() position = 'after';
  @Input() size = 20;
  @Input() top = 0;
  @Input() bottom = 0;
  @Input() left = 0;
  @Input() right = 0;

  ngOnInit() {}
}
